import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout.jsx';
import Home from './components/Home/Home.jsx';
import SafeHand from './components/SafeHand/SafeHand.jsx';
import About from './components/About/About.jsx';
import Faq from './components/faq/Faq.jsx';
import Services from './components/Services/Services.jsx';
import Contact from './components/Contact/Contact.jsx';
import Products from './components/Products/Products.jsx';
import NotFound from './components/NotFound/NotFound.jsx';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="safehand" element={<SafeHand />} />
            <Route path="services" element={<Services />} />
            <Route path="portfolio" element={<Products />} />
            <Route path="about" element={<About />} />
            <Route path="faq" element={<Faq />} />
            <Route path="contact" element={<Contact />} />
            {/* old URLs keep working */}
            <Route path="service" element={<Navigate to="/services" replace />} />
            <Route path="products" element={<Navigate to="/portfolio" replace />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
